import {Component, OnInit} from '@angular/core';
import {SocialAuthService} from "@abacritt/angularx-social-login";
import {Router} from "@angular/router";
import { PatientsApplicationsService } from './shared/services/patients-applications.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  constructor (private socialAuthService: SocialAuthService, private readonly router: Router, public patientDataService: PatientsApplicationsService) {
  }

  ngOnInit(): void {
    this.check()
  }

  check() {
    this.socialAuthService.authState.subscribe((res: any) => {
     if(!res){
       this.router.navigate(['/login']);
     }
    });
  }


}
